<template>
    <div class="line-label-wrapper">
        <div class="line-label-line"></div>
        <div class="line-label-text" v-if="widget.props.label1">
            {{ widget.props.label1 }}
            <span class="line-label-desc" v-if="widget.props.label2">{{ widget.props.label2 }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "LabelWithLine",
    props: ["widget"],
    computed: {}
};
</script>

<style scoped lang="less">
.line-label-wrapper {
}

.line-label-line {
    border-top: 1px solid #e3e3e3;
    margin-bottom: 5px;
}
.line-label-text {
    padding-right: 8px;
    text-align: left;
    font-weight: bold;
}
.line-label-desc {
    color: #999;
    font-weight: normal;
}
</style>
